<template>

  <div>

    <user-list-add-new
      :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
      @refetch-data="refetchData"
      saveType="influencer"
      v-if="!isFenomen"
    />
    <!-- Filters -->
    <users-list-filters
          :deleted-filter.sync="deletedFilter"
          :deleted-options="deletedOptions"
          v-if="!isFenomen"
        />
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row v-if="!isFenomen">

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entries</label>
          </b-col>
          
          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
              />
              <b-button
                variant="primary"
                @click="isAddNewUserSidebarActive = true"
              >
                <span class="text-nowrap">Fenomen Ekle</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>
      
      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchUsers"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Fenomen bulunamadı"
        :sort-desc.sync="isSortDirDesc"
      >


      <!-- Loading Slot -->
      <template #table-busy>
        <div class="text-center my-2 text-muted">
          <b-spinner small class="mr-1"  />
          <span>Fenomenler yükleniyor...</span>
        </div>
      </template>
      
        <!-- Column: User -->
        <template #cell(user)="data">
          <b-media vertical-align="center">
            <template #aside>
              <b-avatar
                size="32"
                :src="data.item.avatar"
                :text="avatarText(data.item.fullName)"
                :variant="`light-${resolveUserRoleVariant(data.item.role)}`"
                :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
              />
            </template>
            <b-link
              :to="{ name: 'apps-users-view', params: { id: data.item.id } }"
              class="font-weight-bold d-block text-nowrap"
            >
              {{ data.item.fullName }}
            </b-link>
            <small class="text-muted">@{{ data.item.username }}</small>
          </b-media>
        </template>
        
        <template #cell(created_date)="data">
          {{ formatDate(data.item.created_date) }}
        </template>
        
        <template #cell(verify_date)="data">
          {{ data.item.verify_date ? formatDate(data.item.verify_date) : ''}}
        </template>

        <!-- Column: Status -->
        <template #cell(username)="data">
          {{ data.item.id }}
          <b-link :to="{ name : 'influencer-card', params: { id: data.item.id } }" target="_blank" rel="noopener noreferrer">
            <feather-icon icon="InstagramIcon" size="22" />
            {{ data.item.username }}
          </b-link>
        </template>

        <!-- Column: Status -->
        <template #cell(verify)="data">
          <b-badge
            pill
            :variant="`light-${resolveUserVerify(data.item.verify)}`"
            class="text-capitalize"
          >
            {{ data.item.verify ? 'Verified' : 'Not Verified' }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item :to="{ name: 'influencer-detail', params: { id: data.item.id } }">
              <feather-icon icon="FileTextIcon" />
              <span class="align-middle ml-50">Detayı Gör</span>
            </b-dropdown-item>


            <b-dropdown-item @click="deleteUser(data.item)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Arşive Ekle</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalUsers"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BSpinner
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import useUsersList from '@/components/user/useUsersList'
import UsersListFilters from '@/components/user/UsersListFilters.vue'
import UserListAddNew from '@/components/user/UserListAddNew.vue'

export default {
  components: {
    UserListAddNew,
    UsersListFilters,

    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,

    vSelect,
  },
  created () {
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'app-user'


    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)

    const deletedOptions = [
      { label: 'Aktif Fenomenler', value: '0' },
      { label: 'Arşivlenenler', value: '1' },
    ]

    const {
      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      deleteUser,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      resolveUserVerify,

      // Extra Filters
      deletedFilter,

    } = useUsersList('influencer')

    return {

      // Sidebar
      isAddNewUserSidebarActive,

      fetchUsers,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      deleteUser,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      // Filter
      avatarText,

      resolveUserVerify,

      deletedOptions,

      // Extra Filters
      deletedFilter,

    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
